import React from 'react';
import clsx from 'clsx';
import { IProps } from './MapsWysiwygBlock.interface';
import './MapsWysiwygBlock.styles.css';
import BlockWrapper from '@/layouts/BlockWrapper/BlockWrapper.component';
import ContentWrapper, { ContentColumn } from '@/layouts/ContentWrapper/ContentWrapper.component';
import Heading from '@/elements/Heading/Heading.component';
import { cleanHTML } from '@/utils/sanitizeHTML'; // Assuming sanitizeHtml is a named export

const MapsWysiwygBlock: React.FC<IProps> = ({
    className,
    heading,
    content,
    iframeSrc,
    iframeTitle = 'Interactive Map',
    iframeHeight = '450px',
    ...blockWrapperProps
}) => {
    const sanitizedContent = cleanHTML(content || '');

    return (
        <BlockWrapper className={clsx('mapsWysiwygBlock', className)} {...blockWrapperProps}>
            <ContentWrapper>
                <ContentColumn>
                    {heading && (
                        <Heading level={2} className="mapsWysiwygBlock__heading" html={heading} />
                    )}
                    <div className="mapsWysiwygBlock__layout-wrapper">
                        {iframeSrc && (
                            <div className="mapsWysiwygBlock__iframe-container">
                                <iframe
                                    src={iframeSrc}
                                    title={iframeTitle}
                                    width="100%"
                                    height={iframeHeight}
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    allowFullScreen
                                    // Page may set Referrer-Policy: same-origin, which strips
                                    // Referer on cross-site iframe loads and breaks Maps API keys.
                                    referrerPolicy="strict-origin-when-cross-origin"
                                />
                            </div>
                        )}
                        {sanitizedContent && (
                            <div
                                className="mapsWysiwygBlock__wysiwyg-content"
                                dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                            />
                        )}
                    </div>
                </ContentColumn>
            </ContentWrapper>
        </BlockWrapper>
    );
};

export { MapsWysiwygBlock };
